import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "content", "defaultTab"];
  static classes = ["selected"];

  connect() {
    let defaultIndex = 0;
    if (this.hasDefaultTabTarget) {
      const defaultTab = this.defaultTabTarget;
      defaultIndex = this.tabTargets.indexOf(defaultTab);
      // Fallback if defaultTab is not in tabTargets
      if (defaultIndex === -1) {
        defaultIndex = 0;
      }
    }
    this.showTab(defaultIndex); // Show the default tab or first tab
  }

  selectTab(event) {
    const index = this.tabTargets.indexOf(event.currentTarget);
    this.showTab(index);
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle(this.selectedClass, i === index); // Add 'selected' class to the active tab
    });

    this.contentTargets.forEach((content, i) => {
      if (content.classList.contains(this.selectedClass)) {
        content.dispatchEvent(
          new CustomEvent("tabs:deselected", {
            bubbles: true,
            detail: { index },
          })
        ); // Dispatch custom event
      }
      content.classList.toggle("no-show", i !== index);
      content.classList.toggle(this.selectedClass, i === index); // Add 'selected' class to the active content
      if (i === index) {
        content.dispatchEvent(
          new CustomEvent("tabs:selected", { bubbles: true, detail: { index } })
        ); // Dispatch custom event
      }
    });
  }
}
